import { gql } from '@apollo/client';

export const ADD_COMMENT = gql`
    mutation AddComment(\$comment: String!,\$username:String!,\$email:String!,\$blog:Int!) {
        insert_comments_one(object:{comment:\$comment,username:\$username,email:\$email,blog:\$blog}) {
            comment
            id
            username
            email
      }
    }
  `;
